import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { fetchCookiePolicy, LegalDocument } from '@/src/services/legalService';

export const CookiePolicyScreen: React.FC = () => {
  const [cookieData, setCookieData] = useState<LegalDocument | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchCookiePolicy().then(data => {
      if (active) {
        setCookieData(data);
        setLoading(false);
      }
    });
    return () => { active = false; };
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20 bg-[#3a3430]">
        <div className="w-12 h-12 border-2 border-white/20 border-t-[#F26522] rounded-full animate-spin mb-4"></div>
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/60 font-heading">Syncing Cookie Directives...</p>
      </div>
    );
  }

  return (
    <div className="bg-[#3a3430] text-white p-6 md:p-10 flex flex-col h-full animate-in fade-in duration-200">
      <header className="border-b border-white/[0.06] pb-4 mb-6 shrink-0 flex flex-col md:flex-row md:items-end md:justify-between gap-3">
        <div>
          <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#F26522] block mb-1 font-heading">eNvesta AI Legal</span>
          <h2 className="text-2xl font-bold tracking-tight font-heading text-white leading-none">Cookies Policy</h2>
        </div>
        <div className="text-left md:text-right">
          <span className="text-[10px] font-medium uppercase tracking-widest text-white/60 block font-heading">Version: {cookieData?.version || '1.0.0'}</span>
          <span className="text-[10px] text-white/40 block mt-0.5">Effective: {cookieData?.effectiveDate || 'June 15, 2026'}</span>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto max-h-[50vh] pr-2 text-sm text-white/70 leading-relaxed space-y-4 no-scrollbar border-b border-white/[0.06] mb-6">
        <div className="markdown-body prose prose-invert max-w-none">
          <ReactMarkdown
            components={{
              a: ({ href, children, ...props }) => {
                const isDpaLink = href === '/legal/dpa';
                const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
                  if (isDpaLink) {
                    e.preventDefault();
                    
                    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    const isWebView = typeof window !== 'undefined' && (
                      /wv|WebView/i.test(navigator.userAgent) ||
                      window.location.protocol === 'file:' ||
                      window.location.protocol === 'capacitor:' ||
                      window.location.protocol === 'chrome-extension:' ||
                      !(window.location.protocol.startsWith('http'))
                    );

                    if (isMobile || isWebView) {
                      window.location.href = `${window.location.origin}/legal/dpa`;
                    } else {
                      window.open(`${window.location.origin}/legal/dpa`, '_blank');
                    }
                  }
                };
                return (
                  <a
                    href={href}
                    onClick={handleClick}
                    className="text-[#F26522] hover:text-[#F26522]/80 font-semibold underline cursor-pointer transition-colors"
                    {...props}
                  >
                    {children}
                  </a>
                );
              }
            }}
          >
            {cookieData?.content || ''}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};
